import { Box, Container } from '@mui/material'

import { useT } from '@clara/locale'
import { EmptyState } from '@clara/ui'

import { ReactComponent as ProcessingImg } from 'assets/images/artwork-manage-processing.svg'

export function ManageReimbursementProcessing() {
  const { t } = useT('reimbursements')

  return (
    <Container
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <EmptyState
        direction="row"
        headline={t('manage.processing.headline')}
        tagline={t('manage.processing.tagline')}
        renderImage={() => (
          <Box sx={(theme) => ({ width: `${theme.spacing(21)}` })}>
            <ProcessingImg />
          </Box>
        )}
      />
    </Container>
  )
}
